import { render, staticRenderFns } from "./globalUploader.vue?vue&type=template&id=b247582e&scoped=true&"
import script from "./globalUploader.vue?vue&type=script&lang=js&"
export * from "./globalUploader.vue?vue&type=script&lang=js&"
import style0 from "./globalUploader.vue?vue&type=style&index=0&id=b247582e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b247582e",
  null
  
)

export default component.exports